<template>
    <v-container
        fluid
        class="mb-5"
        data-v-sticky-container
    >
        <v-row>
            <v-col
                cols="12"
                md="3"
            >
                <card-usuario-etapas
                    v-sticky="optionsSticky"
                    :nue="empleadoDatos.Id_Empleado"
                    :titles="titles"
                    :set-section="setSection"
                    :section-prop="section"
                    :fn-guardar="fnValidar"
                    :validando="validando"
                    :valid="valid"
                    :prop-loading="loading"
                    :edit="idAccion == 1 || idAccion == 2"
                    :save-borrador="objProp.idEstatus == null || objProp.idEstatus == 1"
                    :obj-investigador-principal="objProyecto.participantes.investigadorPrincipal"
                    :fn-set-value="setValue"
                />
            </v-col>
            <v-col
                cols="12"
                md="9"
            >
                <v-alert
                    class="mx-3 pt-5 text-center"
                    color="blue"
                    elevation="2"
                    outlined
                >
                    Para conocer el aviso de privacidad, puede consultarlo desde:
                    <br>
                    <a
                        href="http://www.cepiug.ugto.mx/transparencia/aviso-de-privacidad"
                        target="_blank"
                    >http://www.cepiug.ugto.mx/transparencia/aviso-de-privacidad</a>
                </v-alert>

                <v-alert
                    v-if="objProyecto.idEstatus != 1"
                    class="mx-3 pt-5"
                    border="top"
                    colored-border
                    :type="typeEstatus"
                    elevation="2"
                >
                    El estatus actual del Protocolo del Proyecto es: <b><i>{{ objProyecto.estatus }}</i></b>

                    <!--     <div
                        v-if="objProyecto.idEstatus == 3"
                        class="pt-1"
                    >
                        <b>Justificación: </b> {{ objProyecto.observacionesComite }}
                    </div> -->

                    <div
                        v-if="objProyecto.idEstatus == 3 || objProyecto.idEstatus == 5 || objProyecto.idEstatus == 6 || objProyecto.idEstatus == 9"
                        class="pt-2 text-center"
                    >
                        <v-btn
                            depressed
                            color="blue"
                            class="text-center"
                            rounded
                            text
                            @click="setSection({id: 'observaciones', nombre: 'Observaciones' }); section = 4;"
                        >
                            <v-icon left>
                                mdi-open-in-new
                            </v-icon>
                            Ir a sección 5 Observaciones
                        </v-btn>
                    </div>

                    <div
                        v-if="objProyecto.idEstatus == 7"
                        class="pt-1"
                    >
                        <b>Observaciones: </b> {{ objProyecto.observacionesRevision }}
                    </div>
                </v-alert>
                <v-tabs-items
                    v-if="objProyecto != null"
                    v-model="sectionActive"
                    :vertical="true"
                >
                    <v-tab-item
                        v-for="i in titles"
                        :key="i.id"
                        :value="i.id"
                    >
                        <form-datos-proyecto
                            v-show="i.id == 'datos-del-proyecto'"
                            key="fdp-1"
                            :id-proyecto="idProyecto"
                            :obj="objProyecto.datosProyecto"
                            :id-accion="idAccion"
                            :fn-set-value="setValue"
                            :ban-validar-form="banValidarFormDatosProyecto"
                            :update-valid-forms="updateValidForms"
                            :set-section-prop="setSection"
                        />
                        <form-generales-proyecto
                            v-show="i.id == 'generales-del-proyecto'"
                            key="fg-1"
                            :id-proyecto="idProyecto"
                            :obj="objProyecto.generalesProyecto"
                            :id-accion="idAccion"
                            :fn-set-value="setValue"
                            :ban-validar-form="banValidarFormGeneralesProyecto"
                            :update-valid-forms="updateValidForms"
                            :set-section-prop="setSection"
                        />
                        <form-participantes
                            v-show="i.id == 'participantes'"
                            key="fp-1"
                            :id-proyecto="idProyecto"
                            :obj="objProyecto.participantes"
                            :id-accion="idAccion"
                            :fn-set-value="setValue"
                            :ban-validar-form="banValidarFormParticipantes"
                            :update-valid-forms="updateValidForms"
                            :set-section-prop="setSection"
                        />
                        <form-anexos
                            v-show="i.id == 'anexos'"
                            key="fa-1"
                            :id-proyecto="idProyecto"
                            :id-tipo-proyecto="objProyecto.datosProyecto.idTipoProyecto"
                            :obj="objProyecto.anexos"
                            :id-accion="idAccion"
                            :fn-set-value="setValue"
                            :ban-validar-form="banValidarFormAnexos"
                            :update-valid-forms="updateValidForms"
                            :set-section-prop="setSection"
                            :hay-observaciones="objProyecto.idEstatus == 5 || objProyecto.idEstatus == 6 || objProyecto.idEstatus == 9"
                        />
                        <form-observaciones
                            v-show="i.id == 'observaciones'"
                            key="fo-1"
                            :id-proyecto="idProyecto"
                            :id-accion="idAccion"
                            :update-valid-forms="updateValidForms"
                            :set-section-prop="setSection"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialogNoAnexos"
            persistent
            max-width="500px"
        >
            <v-card>
                <v-card-title
                    style="background-color: #0e345b!important;"
                >
                    <span class="white--text text-h5">Guardar y enviar solicitud</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col
                                cols="12"
                                class="ma-2"
                            >
                                Aún no ha cargado documentos complementarios (opcionales) a su solicitud. ¿Desea continuar?
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        depressed
                        rounded
                        @click="dialogNoAnexos=false;"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        depressed
                        color="#0e345b"
                        rounded                     
                        dark
                        @click="fnGuardar(1); dialogNoAnexos=false;"
                    >
                        continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
            key="snackbarFormProtocoloProyecto"
            v-model="snackbar"
            :bottom="true"
            :multi-line="true"
            :color="snackbarColor"
        >
            {{ snackbarTexto }}
            <v-btn
                dark
                text
                @click="snackbar = false"
            >
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { getProtocolosProyectosBandeja, postProtocoloProyecto, putProtocoloProyecto } from "@/api";
import VueStickyDirective from '@renatodeleao/vue-sticky-directive'

export default {
  name: "FormProtocoloProyecto",
  components: {
    CardUsuarioEtapas: () => import("../formularioProtocoloProyecto/CardUsuarioEtapas"),
    FormDatosProyecto: () => import("../formularioProtocoloProyecto/formDatosProyecto/FormDatosProyecto"),
    FormGeneralesProyecto: () => import("../formularioProtocoloProyecto/formGeneralesProyecto/FormGeneralesProyecto"),
    FormParticipantes: () => import("../formularioProtocoloProyecto/formParticipantes/FormParticipantes"),
    FormAnexos: () => import("../formularioProtocoloProyecto/formAnexos/FormAnexos"),
    FormObservaciones: () => import("../formularioProtocoloProyecto/formObservaciones/FormObservaciones"),
  },
  props: {
    idProyecto: {
      type: Number,
      required: true,
    },
    idAccion: {
      type: Number,
      required: true,
    },
    objProp: {
      type: Object,
      default: null
    },
    fnActualizaInformacion: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      sectionActive: "datos-del-proyecto",
      section: 0,
      titles: [
        { nombre: "Datos del proyecto", id: "datos-del-proyecto", valid: null },
        { nombre: "Generales del proyecto", id: "generales-del-proyecto", valid: null },
        { nombre: "Participantes", id: "participantes", valid: null },
        { nombre: "Anexos", id: "anexos", valid: null },
      ],
      loading: false,
      validando: false,
      snackbar: false,
      snackbarColor: "",
      snackbarTexto: "",
      optionsSticky: {
        topSpacing: 80,
        resizeSensor: true,
        top: true,
        sticked: true
      },
      banValidarFormDatosProyecto: 0,
      banValidarFormGeneralesProyecto: 0,
      banValidarFormParticipantes: 0,
      banValidarFormAnexos: 0,
      objProyecto: {
        participantes: {
          investigadorPrincipal: {
            id: 0,
          }
        }
       },
      dialogNoAnexos: false,
    };
  },
  computed: {
      ...mapState(['empleadoDatos']),
      ...mapGetters("oidc", ["oidcUser"]),
      valid: function () {
        if(this.titles.length == 4) {
          return this.titles.filter(n=>n.valid == true).length == 4 //[0] == undefined
        }
        else {
          return this.titles.filter(n=>n.valid == true).length == 5 //[0] == undefined
        }
      },
      typeEstatus: function () {
        switch(this.objProyecto.idEstatus) {
          case 1:
          case 2:
          case 8:
            return "info";
            break;
          case 3:
            return "error";
            break;
          case 4:
            return "success";
            break;
          case 5:
          case 6:
          case 7:
            return "warning";
            break;
          default:
            return "info";
            break;

        }

        return this.titles.filter(n=>n.valid == true).length == 4 //[0] == undefined
      }
   },
  watch: {
    /* titles: {
        handler (newValue, oldValue) {
            this.valid = this.titles.filter(n=>n.valid == false)[0] == undefined;            
        },
        deep: true,
    }, */
    idAccion: {
      handler (newValue, oldValue) {
        this.fnActualizaInformacion();
      },
    }
  },
  async created () {
    await Object.assign(this.objProyecto, this.objProp);
    if(this.idAccion == 2) {
      this.banValidarFormDatosProyecto++
      this.banValidarFormGeneralesProyecto++
      this.banValidarFormParticipantes++
      this.banValidarFormAnexos++
    }
    if(this.objProyecto.tieneObservaciones) {
      this.titles.push({ nombre: "Observaciones", id: "observaciones", valid: null },)
    }
  },
  async mounted () {
    
    /* if(this.objProyecto.datosProyecto.lstFinanciamiento == undefined) {
      this.objProyecto.datosProyecto.lstFinanciamiento = [];
    } */
  },
  methods: {
    setValue (section, property, value, propertyAdd, idx) {
      if(propertyAdd == undefined) {
        Vue.set(this.objProyecto[section], property, value)

        //this.objProyecto[section][property] =  value;
      }
      else{
        if(idx == undefined) {
          Vue.set(this.objProyecto[section][property], propertyAdd, value)
          //this.objProyecto[section][property][propertyAdd] =  value;
        }
        else{
          if(value == null) {
            this.objProyecto[section][property].splice(idx,1)
          }
          else{
            if(idx == -1) {
              this.objProyecto[section][property].push(value)
            }
            else{
              Object.assign(this.objProyecto[section][property][idx], value);             
            }
          }
        }
      }
    },
    setSection (objSection, updateSection) {
      var self = this;
      this.sectionActive = objSection.id;

      if(updateSection == true) {
        switch(objSection.id) {
          case "datos-del-proyecto":
            this.section = 0;
            break;
          case "generales-del-proyecto":
            this.section = 1;
            break;
          case "participantes":
            this.section = 2;
            break;
          case "anexos":
            this.section = 3;
            break;
          case "observaciones":
            this.section = 4;
            break;
        }
      }
      /* switch(objSection.id) {
        case 'generales-del-proyecto':
          self.banValidarFormDatosProyecto++;
          break;
        case 'participantes':
          self.banValidarFormGeneralesProyecto++;
          break;
        case 'anexos':
          self.banValidarFormParticipantes++;
          break;
      } */

    },
    updateBanValidForms () {
      this.banValidarForms++;
    },
    updateValidForms (idx, value) {
      if(this.titles[idx-1] != undefined) {
        this.titles[idx-1].valid = value;
      }      
    },
    fnValidar (validar) {
      if(validar == true && this.valid == true) {
        if(this.objProyecto.anexos.documentosComplementarios.length == 0) {
          this.dialogNoAnexos = true;
        }
        else{
          this.fnGuardar(1);
        }        
      }
      else{
        this.fnGuardar(0);
      }
    },
    async fnGuardar (est) {
      var self = this;

      self.loading = true;
      self.snackbar = false;
      self.snackbarTexto = "";
      self.snackbarColor = "";

      try{

        this.objProyecto.guardarEnviar = est;

        let response;
        
        if(self.objProyecto.idProyecto == 0) {
          response = await postProtocoloProyecto(this.objProyecto);
        }
        else{
          response = await putProtocoloProyecto(this.objProyecto);
        }

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Guardado correcto") {
              self.snackbarTexto = "Protocolo de Proyecto guardada con éxito";
              self.snackbarColor = "success";
              self.snackbar = true;

              if((this.idAccion == 1) && est == 0) {
                this.objProyecto.idProyecto = response.data.data;
         /*        this.$router
                  .push({
                    name: 'InvFormularioProtocoloProyecto',
                    params: {
                      idAccion: 2,
                      idProyecto: response.data.data
                    },
                  });
                  this.fnActualizaInformacion(); */
                this.$router.push({ path: '/Investigador/FormularioProtocoloProyecto/idAccion/2/idProyecto/' + response.data.data });
                //this.$router.go({ path: '/Investigador/FormularioProtocoloProyecto/idAccion/2/idProyecto/' + response.data.data })
              }

              if(this.idAccion == 2 && est == 0) {
                this.fnActualizaInformacion();//this.$router.go();
              }

              if(est == 1) {
                this.$router.push({ path: '/Investigador/Bandeja' });
              }

              //self.fnOnSave();

              //self.dialog = false;
            }
          } else {
            self.snackbarTexto = "DialogFormServicio: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
          }
        } else {
          self.snackbarTexto = "DialogFormServicio: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
        }
        self.loading = false;

      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "FormProtocoloProyecto: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }

    }
  }
};
</script>
